import { restApi } from '../../../../services/api';
import getRoutePrefix from '../../../../services/utils/getRoutePrefix.util';
import { OrderListTotals } from './order-totals.types';

export const getOrderTotals = (params: Record<string, any>) =>
  restApi.get<OrderListTotals[]>(`${getRoutePrefix()}/orders-list/totals`, params);
